export default "__VITE_ASSET__BR1bQEJO__"